var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextBoxParamIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1994 0.75L8.3242 15.3456L5.58699 7.14422H4.24865L0.832031 17.3728H2.18061L3.0305 14.8163H6.80514L7.65503 17.3728H9.00361L10.7025 12.2581H17.0354L18.7335 17.3728H20.082L14.5386 0.75H13.1994ZM13.8685 2.77883L16.6057 10.9802H11.1313L13.8685 2.77883ZM4.91782 9.17134L6.37636 13.5367H3.45928L4.91782 9.17134Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextBoxParamIcon);
export default __webpack_public_path__ + "static/media/TextBoxParamIcon.c31034917d325349c06263f07066c4ff.svg";
export { ForwardRef as ReactComponent };